/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Col, Input, Row, Form, Button, Modal, DatePicker, message, Table, ConfigProvider } from "antd";
import { useForm } from "antd/lib/form/Form";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { setMAWB } from "../../../actions/MAWB";
import { checkinUser, userAwbLogout } from "../../../actions/userAWB";
import { logoutCheckin } from "../../../config/checkinApi";
import { setPaymentInfo } from "./../../../actions/payment";
import { CSBL_STORAGE_SVC } from "../../../config/webTrackApi";
import enUS from 'antd/lib/locale/en_US';
import QRCode from "qrcode.react";

const AccountInfo = ({ dataLogin }) => {
  const [form] = useForm();
  const [formFee] = useForm();
  const history = useHistory();
  const { token } = useSelector((state) => state.userAwb.dataCheckin);
  const { dataCheckin, currentUser } = useSelector((state) => state.userAwb);
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);

  const handleLogoutCheckin = async () => {
    try {
      await logoutCheckin(token);
      dispatch(checkinUser({}));
      dispatch(setPaymentInfo(undefined));
      dispatch(userAwbLogout());
      localStorage.removeItem("userAWB");
      localStorage.removeItem("checkin");
      localStorage.removeItem("pInfo");
      history.push("/");
      notification.success({
        message: "Đăng xuất thành công!",
        style: { marginRight: "-50%" },
      });
    } catch (error) {
      // console.log(error);
    }
  };

  useEffect(() => {
    if (dataCheckin !== undefined) {
      form.setFieldsValue({
        mawb: dataCheckin.AWB,
        hawb: dataCheckin.COD_HWB_NUM,
        pcs: dataCheckin.CARGOPIECE,
        weight: dataCheckin.CARGOWEIGHT,
        status: dataCheckin.COD_STS,
        flightNo: dataCheckin.FLIGHTNUMBER,
        flightDate: moment(dataCheckin.FLIGHTDATE).format("DD MMM YYYY"),
        location: dataCheckin.CONTAINER_LOC,
        description: dataCheckin.COMMODITY_DES,
        dateCre: moment(dataCheckin.CREATEDATE).format("DD MMM YYYY"),
        nsw: dataCheckin.CIMP,
        chargeWeight: dataCheckin.EXT_WGT
      });
    }
  }, [dataCheckin]);

  function buildPara({
    shipmentType = 'S',
    importExportFlag = 'I',
    mode = 'I',
    awbPrefix,
    awbNumber,
    awbSfx = 'P',
    hawb,
    pcs,
    chargeWeight,
    storeageCode = 'GEN',
    storeageCode2 = 'GEN',
    flightDate,
    dateCre,
    userCode
  }) {
    const formatDate = (dateStr) => {
      const date = new Date(dateStr);
      const day = String(date.getDate()).padStart(2, '0');
      const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
      const year = date.getFullYear();
      const hour = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      return `${day}${month}${year} ${hour}:${min}`;
    };

    return [
      shipmentType,               // 1. S
      importExportFlag,           // 2. I
      mode,                       // 3. I
      awbPrefix,                  // 4. 205
      awbNumber,                  // 5. 74378496
      awbSfx,                // 7. P
      hawb,                       // 6. NEC40724213
      pcs,                        // 8. 0
      chargeWeight,               // 9. 0
      storeageCode,               // 10. GEN
      storeageCode2,              // 11. GEN
      formatDate(flightDate),     // 12. 03JUL2025 08:00
      formatDate(dateCre),        // 13. 05JUL2025 17:00
      userCode                    // 14. NAMVV
    ].join('#');
  }

  const [estimatedFeeData, setEstimatedFeeData] = useState([]);
  const [loadingFee, setLoadingFee] = useState(false);
  const estimatedFee = async () => {
    if (!dataCheckin || !dataCheckin.COD_AWB_PFX || !dataCheckin.COD_AWB_NUM) {
      console.error("Missing required data for estimated fee calculation");
      return; // Stop the function if data is incomplete
    }
    const values = await formFee.validateFields();

    const selectedDate = moment(values.selectedDate);

    // Kiểm tra ngày nhận
    const now = moment();
    const maxDate = now.add(30, 'days');

    if (!selectedDate || !values.selectedDate) {
      message.error("Vui lòng chọn ngày nhận");
      return;
    }

    if (selectedDate.isBefore(moment())) {
      message.error("Không được chọn ngày trong quá khứ");
      return;
    }

    if (selectedDate.isAfter(maxDate)) {
      message.error("Không được chọn quá 30 ngày kể từ hôm nay");
      return;
    }

    const kind = 'YSHP';
    try {
      setLoadingFee(true);
      // Gọi lần 1: IMP_CALC_SVC_CHG_XML
      const para = buildPara({
        shipmentType: 'S',
        importExportFlag: dataCheckin.FLG_IMP_EXP || 'I',
        mode: dataCheckin.FLG_IMP_EXP || 'I',
        awbPrefix: dataCheckin.COD_AWB_PFX,
        awbNumber: dataCheckin.COD_AWB_NUM,
        awbSfx: dataCheckin.COD_AWB_SFX || 'P',
        hawb: dataCheckin.COD_HWB_NUM,
        pcs: dataCheckin.TOTAL_PCS || 0,
        chargeWeight: dataCheckin.EXT_WGT  || 0,
        storeageCode: 'GEN',
        storeageCode2: 'GEN',
        flightDate: dataCheckin.FLIGHTDATE,
        dateCre: values.selectedDate,
        userCode: currentUser.username || 'NAMVV'
      });
      const svcResponse = await CSBL_STORAGE_SVC('IMP_CALC_SVC_CHG_XML', kind, para);
      if (!svcResponse || !svcResponse.data || !svcResponse.data.mCol || !svcResponse.data.mCol.BIL_CHG_XML_Cls) {
        message.error("Có lỗi xảy ra trong quá trình tính phí. Vui lòng liên hệ với TCS để được hỗ trợ AAA.");
        return;
      }
      const svcBilChgXmlCls = svcResponse.data.mCol.BIL_CHG_XML_Cls.filter(x => Number(x.AMT_GROSS || 0) + Number(x.AMT_TAX || 0) > 0) || [];
      const mergedResult = [...svcBilChgXmlCls];

      // Gọi lần 2: IMP_CALC_STG_CHG_XML
      try {
        const stgResponse = await CSBL_STORAGE_SVC('IMP_CALC_STG_CHG_XML', kind, para);
        if (stgResponse && stgResponse.data.mCol && Array.isArray(stgResponse.data.mCol.BIL_CHG_XML_Cls)) {
          // Lọc các mục có tổng số tiền lớn hơn 0
          const stgBilChgXmlCls = stgResponse.data.mCol.BIL_CHG_XML_Cls.filter(x => Number(x.AMT_GROSS || 0) + Number(x.AMT_TAX || 0) > 0) || [];
          mergedResult.push(...stgBilChgXmlCls);
        }
      } catch (error) {
        console.error("Error fetching storage charges:", error);
      }
      
      
      setEstimatedFeeData(mergedResult);
      setLoadingFee(false);
    } catch (error) {
      console.error("Error fetching estimated fee:", error);
      message.error("Có lỗi xảy ra trong quá trình tính phí. Vui lòng liên hệ với TCS để được hỗ trợ.");
      setLoadingFee(false);
    }
  };

  const formatCurrency = (value) =>
  Number(value || 0).toLocaleString('vi-VN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const feeColumns = [
    { title: 'Charge Code', dataIndex: 'CHG_DES', key: 'CHG_DES' },
    { title: 'Quantity', dataIndex: 'QTY', key: 'QTY' },
    {
      title: 'Gross Amt',
      dataIndex: 'AMT_GROSS',
      key: 'AMT_GROSS',
      render: (value) => formatCurrency(value),
    },
    {
      title: 'VAT Amt',
      dataIndex: 'AMT_TAX',
      key: 'AMT_TAX',
      render: (value) => formatCurrency(value),
    },
    {
      title: 'Total Amt',
      key: 'amount',
      render: (_, record) => {
        const gross = Number(record.AMT_GROSS || 0);
        const vat = Number(record.AMT_TAX || 0);
        const total = gross + vat;
        return formatCurrency(total);
      }
    }
  ];

  const openModal = () => {
    setVisible(true);
    formFee.setFieldsValue({
      selectedDate: moment().add(30, 'minutes')
    });
    setEstimatedFeeData([]);
  }

  const onCloseModal = () => {
    setVisible(false);
    formFee.resetFields();
    setEstimatedFeeData([]);
  }

  return (
    <Row style={{ flexDirection: 'column' }} className="login-form-wrapper">
      <Row className="login-form-title-wrapper">
        <Col className="login-form-title" offset={4}>
          <h2>Thông tin tài khoản</h2>
        </Col>
      </Row>
      <Row style={{ justifyContent: 'center', display: 'flex' }}>
        <Col style={{ margin: '0 auto' }} span={18}>
          <Form form={form} className="account-info" layout="vertical">
            <Row gutter={[5, 0]}>
              <Col span={24} md={4} xl={4}>
                <Form.Item name="mawb" label="MAWB">
                  <Input readOnly />
                </Form.Item>
              </Col>
              <Col span={24} md={4} xl={4}>
                <Form.Item name="hawb" label="HAWB">
                  <Input readOnly />
                </Form.Item>
              </Col>
              <Col span={24} md={2} xl={2}>
                <Form.Item name="pcs" label="PCS">
                  <Input readOnly />
                </Form.Item>
              </Col>
              <Col span={24} md={3} xl={3}>
                <Form.Item name="weight" label="Weight">
                  <Input readOnly />
                </Form.Item>
              </Col>
              <Col span={24} md={3} xl={3}>
                <Form.Item name="chargeWeight" label="Charge weight">
                  <Input readOnly />
                </Form.Item>
              </Col>
              <Col span={24} md={2} xl={2}>
                <Form.Item name="status" label="Status">
                  <Input readOnly />
                </Form.Item>
              </Col>
              <Col span={24} md={3} xl={3}>
                <Form.Item name="flightNo" label="Flight No">
                  <Input readOnly />
                </Form.Item>
              </Col>
              <Col span={24} md={3} xl={3}>
                <Form.Item name="flightDate" label="Flight Date">
                  <Input readOnly />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[5, 0]}>
              <Col span={24} md={2} xl={2}>
                <Form.Item name="location" label="Location">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={24} md={9} xl={9}>
                <Form.Item name="description" label="Commodity Description">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={24} md={5} xl={5}>
                <Form.Item name="dateCre" label="Date Cre">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={24} md={8} xl={8}>
                <Form.Item name="nsw" label="Irr Info">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={8} style={{ justifyContent: 'flex-end', display: 'flex' }}>
                <Button
                  className="btn-payment"
                  style={{ width: 'fit-content' }}
                  onClick={() => {
                    dispatch(
                      setMAWB({
                        first: dataCheckin.COD_AWB_PFX,
                        last: dataCheckin.COD_AWB_NUM,
                        suffix: dataCheckin.COD_AWB_SFX,
                        hawb: dataCheckin.COD_HWB_NUM,
                      }),
                    );
                    localStorage.setItem(
                      'MAWB',
                      JSON.stringify({
                        first: dataCheckin.COD_AWB_PFX,
                        last: dataCheckin.COD_AWB_NUM,
                        suffix: dataCheckin.COD_AWB_SFX,
                        hawb: dataCheckin.COD_HWB_NUM,
                      }),
                    );
                    history.push('/awb/checkout');
                  }}>
                  {/* {t("header.submit")} */} Tiếp tục
                </Button>
              </Col>
              <Col span={8} style={{ justifyContent: 'flex-end', display: 'flex' }}>
                <Button
                  className="btn-payment"
                  style={{ width: 'fit-content' }}
                  onClick={openModal}>
                  Xem Phí dự kiến
                </Button>
              </Col>
              <Col span={8} style={{ justifyContent: 'flex-end', display: 'flex' }}>
                <Button
                  className="btn-payment"
                  style={{ width: 'fit-content' }}
                  onClick={handleLogoutCheckin}>
                  {/* {t("header.submit")} */} Đăng xuất
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      {visible && (
        <Modal
          title="Xem Phí dự kiến"
          visible={visible}
          onCancel={onCloseModal}
          footer={null}
          width={800}
          confirmLoading={loadingFee}>
          <div>
            <Form form={formFee} layout="vertical">
              <Row gutter={[5, 0]}>
                <Col span={24} md={14} xl={14}>
                  <ConfigProvider locale={enUS}>
                    <Form.Item name="selectedDate" label="Ngày nhận">
                      <DatePicker
                        readOnly
                        style={{ width: '100%' }}
                        showTime
                        format={(value) => value.format('DD MMM YYYY HH:mm').toUpperCase()}
                        placeholder="Chọn ngày giờ"
                        clearIcon={false}
                      />
                    </Form.Item>
                  </ConfigProvider>
                </Col>
                <Col span={24} md={10} xl={10} style={{ marginTop: '2px' }}>
                  <Form.Item label=" " colon={false}>
                    <Button
                      className="btn-payment"
                      style={{ width: 'fit-content' }}
                      onClick={estimatedFee}
                      loading={loadingFee}>
                      Tính Phí
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <Table
              rowKey={(_, index) => index}
              dataSource={estimatedFeeData}
              columns={feeColumns}
              pagination={false}
              bordered
            />
            <div style={{ marginTop: '20px', textAlign: 'right' }}>
              <i style={{ color: 'red' }}>
                Số tiền này chỉ là dự tính và chỉ áp dụng với lô hàng chưa giao cho khách.
              </i>
            </div>
            <div style={{ marginTop: '20px', textAlign: 'left' }}>
              {dataCheckin?.COD_HWB_NUM ? (
                <div>
                  <div>
                    Trường hợp Quý khách thanh toán bằng hình thức chuyển khoản vào tài khoản của Công ty TCS, vui lòng thể hiện nội dung 
                    "THANH TOAN PHI DICH VU CHO LO HANG MAWB {dataCheckin?.COD_AWB_PFX}-
                    {dataCheckin?.COD_AWB_NUM} HAWB {dataCheckin?.COD_HWB_NUM}"
                  </div>
                  <QRCode
                    value={`THANH TOAN PHI DICH VU CHO LO HANG MAWB ${dataCheckin?.COD_AWB_PFX}-
                      ${dataCheckin?.COD_AWB_NUM} HAWB ${dataCheckin?.COD_HWB_NUM}`}
                    size={128}
                  />
                </div>
              ) : (
                <div>
                  <div>
                    Trường hợp Quý khách thanh toán bằng hình thức chuyển khoản vào tài khoản của Công ty TCS, vui lòng thể hiện nội dung 
                    "THANH TOAN PHI DICH VU CHO LO HANG MAWB {dataCheckin?.COD_AWB_PFX}-
                    {dataCheckin?.COD_AWB_NUM}"
                  </div>
                  <QRCode
                    value={`THANH TOAN PHI DICH VU CHO LO HANG MAWB ${dataCheckin?.COD_AWB_PFX}-
                      ${dataCheckin?.COD_AWB_NUM}`}
                    size={128}
                  />
                </div>
              )}
            </div>
            <Row gutter={[5, 0]} style={{ marginTop: '20px' }}>
              <Col span={24} style={{ display: 'flex', justifyContent: 'end' }}>
                <Button
                  className="btn-payment"
                  style={{ width: 'fit-content' }}
                  onClick={onCloseModal}>
                  Đóng
                </Button>
              </Col>
            </Row>
          </div>
        </Modal>
      )}
    </Row>
  );
};
export default AccountInfo;
